'use strict';

import template from './dashboard.html';
import controller from './dashboard.controller';

const DashboardComponent = {
    template,
    controller
};

export default DashboardComponent;



// WEBPACK FOOTER //
// ./src/app/components/admin/dashboard/dashboard.component.js